var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sfcStartNodeContainer", class: { vertical: _vm.vertical } },
    [
      _c("div", { staticClass: "sfcStartNodeContent" }, [
        _vm._v(_vm._s(_vm.data.title)),
      ]),
      _c("SFCArrowLine", { attrs: { data: _vm.data } }),
      _c("SFCAddNode", {
        attrs: {
          nodeList: _vm.nodeList,
          nodeData: _vm.data,
          btnType: _vm.isMouseEnter ? "dot" : "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }